import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

const DateRangeComponent = ({
	item,
	onChange,
	itemId,
	showClearDates = false,
	displayFormat = 'MMM DD',
	single = false
}) => {
	const [fromDate, setFromDate] = useState(item.value1);
	const [toDate, setToDate] = useState(item.value2);
	const [focusedInput, setFocusedInput] = useState(null);
	const [focused, setFocused] = useState(false); // For NotUsedSince

	useEffect(() => {
		setFromDate(item.value1);
		setToDate(item.value2);
	}, [item]);

	const saveDateRange = async (startDate, endDate) => {
		let from = startDate ? startDate.format('YYYY-MM-DD') : null;
		let to = endDate ? endDate.format('YYYY-MM-DD') : null;
		setFromDate(from);
		setToDate(to);
		if (startDate && endDate) {
			onChange(from, to, itemId);
		}
		if (!startDate && !endDate && showClearDates) {
			onChange(from, to, itemId);
		}
	};

	const saveSingleDate = async (newDate) => {
		let formattedDate = newDate ? newDate.format('YYYY-MM-DD') : null;
		setFromDate(formattedDate);
		onChange(formattedDate, null, itemId);

		if (!newDate && showClearDates) {
			onChange(null, itemId);
		}
	};

	return (
		<>
			{single ? (
				<div className="task-date-picker">
					<SingleDatePicker
						date={toDate ? moment(toDate, 'YYYY-MM-DD') : null}
						onDateChange={(date) => saveSingleDate(date)}
						focused={focused}
						onFocusChange={({ focused }) => setFocused(focused)}
						id="your_unique_date_id"
						daySize={30}
						numberOfMonths={1}
						displayFormat={displayFormat}
						isOutsideRange={() => false}
						showClearDate={showClearDates}
					/>
				</div>
			) : (
				<DateRangePicker
					startDate={fromDate ? moment(fromDate, 'YYYY-MM-DD') : null}
					startDateId="your_unique_start_date_id"
					endDate={toDate ? moment(toDate, 'YYYY-MM-DD') : null}
					endDateId="your_unique_end_date_id"
					onDatesChange={({ startDate, endDate }) => saveDateRange(startDate, endDate)}
					focusedInput={focusedInput}
					onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
					daySize={30}
					numberOfMonths={1}
					displayFormat={displayFormat}
					isOutsideRange={() => false}
					showClearDates={showClearDates}
				/>
			)}
		</>
	);
};

export default DateRangeComponent;
